export enum MarkerType {
  DRAG_START = 1,
  LOADING,
  BLANK,
  COVERAGE,
  STORE,
  FAVORITE,
  CURRENT,
  NUMBER_LABEL,
  ROUND_TRIP,
  DASHBOARD,
}
